<template>
  <transition :name="isDroppable ? 'fade' : null">
    <drop-helper v-if="enabled" :dropOptions="dropOptions"></drop-helper>
  </transition>
</template>

<script>
import DropHelper from '@/components/DragDrop/DropHelper';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';

export default {
  components: { DropHelper },
  props: ['item', 'workspace'],
  data() {
    return {
      accepts: ['folder', 'context'],
      savedDragData: null
    };
  },
  watch: {
    enabled: function(n, o) {
      if (n) {
        console.log('save data');
        //  store the value of dragged data so when drag stops we still have it to execute on
        this.savedDragData = this.draggedData;
      }
    }
  },
  computed: {
    ...mapGetters('workspaces', ['workspaces']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapState('components/dragdrop', ['draggedData']),
    dropOptions() {
      return {
        accepts: this.accepts,
        zones: [
          {
            id: 'dropMoveNoteBlock',
            show: this.isDroppable,
            style: {
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 100
            },
            hoverClass: 'q-dropzone-full',
            onDrop: () => this.moveToFolder()
          }
        ]
      };
    },
    enabled() {
      const matchedAccepts = this.accepts.filter(value => this.draggedData.types.includes(value));
      return this.dragging && matchedAccepts.length > 0;
    },
    isDragged() {
      return this.draggedData.ids.includes(this.item.id);
    },
    isDescendent() {
      //  Folders can't be dropped into their descendents
      const folders = Object.values(this.workspace.folders);
      if (this.item.type == 'folder' && this.draggedData.types.includes('folder')) {
        const dragItem = this.draggedData.ids[0];
        const dragFolder = this.workspace.folders[dragItem];
        const descendents = buildDescendents(dragFolder);
        return descendents.includes(this.item.id);
      } else {
        return false;
      }

      function buildDescendents(folder) {
        console.log('build descendents');
        const descendents = [];
        const children = folders.filter(f => f.parent == folder.id);
        children.forEach(c => {
          descendents.push(c.id);
          buildDescendents(c);
        });
        return descendents;
      }
    },
    isSameWorkspace() {
      return (
        this.draggedData.parent.id == this.workspace.id ||
        this.draggedData.parent.id == this.item.id
      );
    },
    isDraggedParent() {
      return this.draggedData.parent.id == this.item.id;
    },
    isSortable() {
      return (
        !this.isDragged &&
        ((this.item.type == 'folder' && this.draggedData.types.includes('folder')) ||
          (this.item.type == 'context' && this.draggedData.types.includes('context')))
      );
    },
    isDroppable() {
      //  is this object  a drop, vs a sort item?
      return (
        !this.isDragged && this.item.type != 'context' && this.isSameWorkspace && !this.isDescendent
      );
    }
  },
  methods: {
    ...mapActions('context', ['moveQuestionsById', 'updateQuestionType']),
    ...mapActions('workspaces', ['updateFolderParent', 'moveContextToFolder']),
    deindent() {
      this.$emit('deindent');
    },
    indent() {
      console.log('indent');
      this.$emit('indent');
    },
    moveToFolder() {
      console.log('mpve to folder', this.item);
      const items = this.savedDragData.ids;
      console.log(this.savedDragData);
      items.forEach(i => {
        if (this.savedDragData.types.includes('folder')) {
          //  move folder
          this.updateFolderParent({
            folderId: i,
            workspaceId: this.workspace.id,
            parentFolderId: this.item.id
          });
        } else {
          // move context
          console.log('move context');
          const currentFolder = Object.values(this.workspace.folders).find(w =>
            w.contexts.includes(i)
          );
          const currentFolderId = currentFolder ? currentFolder.id : this.workspace.id;
          this.moveContextToFolder({
            workspaceId: this.workspace.id,
            currentFolderId,
            newFolderId: this.item.id,
            contextId: i
          });
        }
      });
    }
  }
};
</script>

<style>
.q-dropzone-top {
  border-top: 3px solid #2196f3;
}

.q-dropzone-bottom {
  border-bottom: 3px solid #2196f3;
  margin-bottom: -3px;
}
.q-dropzone-full {
  opacity: 0.3;
  background: #2196f3;
}

.zone-move,
.zone-copy {
  background: rgba(250, 250, 250, 0);
  opacity: 0;
}

.list-item:hover .zone-move,
.list-item:hover .zone-copy {
  background: rgba(250, 250, 250, 0.9);
  transition: 0.5s ease all;
  opacity: 1;
}

.list-item:hover .zone-move .drop-zone-content {
  color: #242424;
  border-radius: 2px;
  font-weight: bold;
  background: rgba(255, 255, 255, 0.76);
  transition: 0.5s ease all;
}

.list-item:hover .zone-move.hover-zone-move .drop-zone-content {
  background: #f77797;
}

.list-item:hover .zone-copy .drop-zone-content {
  color: #242424;
  font-weight: bold;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.76);
  transition: 0.5s ease all;
}

.list-item:hover .zone-copy.hover-zone-copy .drop-zone-content {
  background: #6eeea3;
}

.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
